/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { getBaseInputStyles, getFloatingInputStyles } from '@chegg-ui/input';
import styled, { css } from 'styled-components';
export var FauxInputButton = styled.div.withConfig({
  componentId: "sc-13nh55k-0"
})(["", ""], function (props) {
  return css(["", " &:hover{cursor:", ";}"], getBaseInputStyles(props), props.disabled ? "not-allowed" : "pointer");
});
export var FloatingFauxInputButton = styled.div.withConfig({
  componentId: "sc-13nh55k-1"
})(["", " &:hover{cursor:pointer;}"], function (props) {
  return css(["", ""], getFloatingInputStyles(props));
});
export var NativeSelect = styled.select.withConfig({
  componentId: "sc-13nh55k-2"
})(["", " -webkit-appearance:none;-moz-appearance:none;border-radius:4;&:hover{cursor:pointer;}"], function (props) {
  return getBaseInputStyles(props);
});
export var FloatingNativeSelect = styled.select.withConfig({
  componentId: "sc-13nh55k-3"
})(["", " -webkit-appearance:none;-moz-appearance:none;border-radius:4;background-color:transparent;&:hover{cursor:pointer;}"], function (props) {
  return getFloatingInputStyles(props);
});
export var PlaceholderOrValue = styled.span.withConfig({
  componentId: "sc-13nh55k-4"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:1rem;display:block;"]);